// @flow
import { deleteCreator, getCreator, postCreator, putCreator } from '../../../http';
import environment from '../../../environment';

export const endpoints = Object.freeze({
  SEARCH_ADMIN1: `${environment.apiUrl}/meta/location/admin1`,
  FETCH_PAYMENTS: `${environment.apiUrl}/preferences/payments`,
  POST_PAYMENT: `${environment.apiUrl}/preferences/payment`,
  PUT_PAYMENT: `${environment.apiUrl}/preferences/payment/:id`,
  DELETE_PAYMENT: `${environment.apiUrl}/preferences/payment/:id`,
});

export const searchAdmin1Api = getCreator(fetch, endpoints.SEARCH_ADMIN1);
export const getPaymentsApi = getCreator(fetch, endpoints.FETCH_PAYMENTS);
export const postPaymentApi = postCreator(fetch, endpoints.POST_PAYMENT);
export const putPaymentApi = putCreator(fetch, endpoints.PUT_PAYMENT);
export const deletePaymentApi = deleteCreator(fetch, endpoints.DELETE_PAYMENT);



// WEBPACK FOOTER //
// ./src/modules/preferences/payments/api.js